import { Box, MenuItem, Stack } from '@mui/material';
import { Field, FormikProps } from 'formik';
import { Select, TextField } from 'formik-mui';
import { PAYORDER_STATUSES } from '@sr/dto';
import { DatePickerField } from 'shared/ui/formik-fields/date-picker';
import { BankAccountPicker } from 'shared/ui/formik-fields/bank-account-picker';
import { TransferFormData } from './pay-order-transfer.form';

export const PayOrderTransferFormFields = (_props: FormikProps<TransferFormData>) => {
  return (
    <Box minWidth={420}>
      <Stack direction="column" spacing={2}>
        <Field required name="paymentDate" component={DatePickerField} fullWidth label="Дата" />
        <Field required name="fromAccountId" component={BankAccountPicker} fullWidth label="С какого счета" />
        <Field required name="toAccountId" component={BankAccountPicker} fullWidth label="На какой счет" />
        <Field name="outgoingDocumentNumber" component={TextField} fullWidth label="Номер платежного поручения списания" />
        <Field name="incomingDocumentNumber" component={TextField} fullWidth label="Номер платежного поручения зачисления" />
        <Field required name="amount" component={TextField} fullWidth label="Сумма" />
        <Field required name="description" component={TextField} fullWidth label="Назначение платежа" multiline rows={3} />
        <Field required name="status" component={Select} fullWidth label="Статус">
          {PAYORDER_STATUSES.map((s) => (
            <MenuItem key={s.id} value={s.id}>
              {s.label}
            </MenuItem>
          ))}
        </Field>
      </Stack>
    </Box>
  );
};
